<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col>
        <b-form-group
          label="Название:"
          :invalid-feedback="errors.name"
          :state="states.name"
        >
          <b-form-input
            type="text"
            autofocus
            size="sm"
            :value="item.name"
            :state="states.name"
            :disabled="loading"
            @change="updateValue('name', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Код:"
          :invalid-feedback="errors.code"
          :state="states.code"
        >
          <b-form-input
            type="text"
            size="sm"
            :value="item.code"
            :state="states.code"
            :disabled="loading"
            @change="updateValue('code', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Сайт:"
          :invalid-feedback="errors.website"
          :state="states.website"
        >
          <b-form-input
            type="text"
            size="sm"
            :value="item.website"
            :state="states.website"
            :disabled="loading"
            @change="updateValue('website', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Адрес:"
          :invalid-feedback="errors.address"
          :state="states.address"
        >
          <b-form-input
            type="text"
            size="sm"
            :value="item.address"
            :state="states.address"
            :disabled="loading"
            @change="updateValue('address', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Телефон:"
          :invalid-feedback="errors.phone"
          :state="states.phone"
        >
          <b-form-input
            type="text"
            size="sm"
            :value="item.phone"
            :state="states.phone"
            :disabled="loading"
            @change="updateValue('phone', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Email:"
          :invalid-feedback="errors.email"
          :state="states.email"
        >
          <b-form-input
            type="text"
            size="sm"
            :value="item.email"
            :state="states.email"
            :disabled="loading"
            @change="updateValue('email', $event)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
            label="Лого:"
            :invalid-feedback="errors.imagePath"
            :state="states.imagePath"
        >
          <b-row class="p-0">
            <b-col>
              <file-uploader
                  ref="logoUploader"
                  :disabled="loading"
                  @change="uploadLogo($event)"
              ></file-uploader>
            </b-col>

            <b-col>
              <image-viewer
                  v-if="item.imageUrl"
                  :image="item.imageUrl"
                  @remove="resetLogo()"
              ></image-viewer>
              <div
                  v-if="!item.imageUrl && !$fileManager2.files[logoFileId]"
                  class="text-center"
              >
                <img :src="noPhoto" class="w-50" />
              </div>
              <div
                  v-if="!item.imageUrl && $fileManager2.files[logoFileId]"
                  class="loader"
              >
                <template v-if="!$fileManager2.files[logoFileId].error"><span class="mr-2">{{ $fileManager2.files[logoFileId].progress }}%</span> <b-spinner variant="primary"></b-spinner></template>
                <template v-else>Ошибка при загрузке лого!</template>
              </div>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import ImageViewer from '@/components/ImageViewer.vue';
import FileUploader from '@/components/fields/FileUploader.vue';
import noPhoto from '@/assets/no_photo.png';

export default {
  components: {
    FileUploader,
    ImageViewer,
  },
  props: {
    loading: {
      default: false,
    },
    errors: {
      default: () => ({}),
    },
    states: {
      default: () => ({}),
    },
    item: {
      default: () => ({}),
    },
  },
  data() {
    return {
      noPhoto,
      logoFileId: -1,
    };
  },
  methods: {
    updateValue(field, value) {
      this.$emit('change', {
        field,
        value,
      });
    },
    async uploadLogo(files) {
      this.updateValue('imagePath', '');
      this.updateValue('imageUrl', '');

      this.$fileManager2.upload(files[0]).then((data) => {
        this.$refs.logoUploader.reset();

        if (!data) {
          return;
        }

        this.updateValue('imagePath', data.path);
        this.updateValue('imageUrl', data.url);

        this.logoFileId = -1;
      });

      this.logoFileId = this.$fileManager2.getFileIndex(files[0]);
    },
    resetLogo() {
      this.updateValue('imagePath', '');
      this.updateValue('imageUrl', '');

      this.$refs.logoUploader.reset();
      this.logoFileId = -1;
    },
  },
};
</script>
